import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import request from '@/router/axios';
export var getList = function getList(current, size, params) {
  return request({
    url: '/api/blade-system/menu/list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      current: current,
      size: size
    })
  });
};
export var getLazyList = function getLazyList(parentId, params) {
  return request({
    url: '/api/blade-system/menu/lazy-list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      parentId: parentId
    })
  });
};
export var getLazyMenuList = function getLazyMenuList(parentId, params) {
  return request({
    url: '/api/blade-system/menu/lazy-menu-list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      parentId: parentId
    })
  });
};
export var getMenuList = function getMenuList(current, size, params) {
  return request({
    url: '/api/blade-system/menu/menu-list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      current: current,
      size: size
    })
  });
};
export var getMenuTree = function getMenuTree(tenantId) {
  return request({
    url: '/api/blade-system/menu/tree',
    method: 'get',
    params: {
      tenantId: tenantId
    }
  });
};
export var remove = function remove(ids) {
  return request({
    url: '/api/blade-system/menu/remove',
    method: 'post',
    params: {
      ids: ids
    }
  });
};
export var add = function add(row) {
  return request({
    url: '/api/blade-system/menu/submit?tenantId=' + row.tenantId,
    method: 'post',
    data: row
  });
};
export var update = function update(row) {
  return request({
    url: '/api/blade-system/menu/submit?tenantId=' + row.tenantId,
    method: 'post',
    data: row
  });
};
export var getMenu = function getMenu(id, tenantId) {
  return request({
    url: '/api/blade-system/menu/detail?tenantId=' + tenantId,
    method: 'get',
    params: {
      id: id
    }
  });
};
export var getTopMenu = function getTopMenu() {
  return request({
    url: '/api/blade-system/menu/top-menu',
    method: 'get'
  });
};
export var getRoutes = function getRoutes(topMenuId) {
  return request({
    url: '/api/blade-system/menu/routes',
    method: 'get',
    params: {
      topMenuId: topMenuId
    }
  });
};